import React from 'react';

export interface StepperItemProps extends React.HTMLAttributes<HTMLDivElement> {}

function StepperItem({ className = '', children, ...props }: StepperItemProps): JSX.Element {
  return (
    <div className={`stepper-item ${className}`} role="listitem" {...props}>
      {children}
    </div>
  );
}

export default StepperItem;
